import { Notifications } from '../models/Notifications';
import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

interface NotificationsState extends ApiState {
  notifications?: Notifications
}

export default requestReducer<NotificationsState>('UPDATE_NOTIFICATIONS')